import i18n from 'i18next';
import { splitMoney } from '../Results/utils';
import { Currency } from '../enums';
import { CurrencyMetaMap } from './constants';
export const getFormattedAmount = (money, multiplyBy = 1, roundType, splitMoneyMin = 10000) => {
    let amount = money === null || money === void 0 ? void 0 : money.amount;
    if (amount === 0) {
        return '0';
    }
    if (!amount) {
        return '';
    }
    switch (roundType) {
        case 'ceil':
            amount = Math.ceil(amount);
            break;
        case 'floor':
            amount = Math.floor(amount);
            break;
        case 'round':
            amount = Math.round(amount);
            break;
    }
    amount *= multiplyBy;
    return splitMoney(amount, 2, splitMoneyMin).join(' ');
};
export const formatCompactMoneyAmount = (amount, currency, limit = 6, pattern = '{{amount}} {{suffix}}.') => {
    if (amount.toString().length < limit) {
        return splitMoney(amount, 2, 1000).join(' ');
    }
    // округляем, убрав дробную часть
    const roundedAmount = Math.round(amount);
    if (roundedAmount.toString().length < limit) {
        return splitMoney(roundedAmount, 0, 1000).join(' ');
    }
    const shortAmount = Math.round(roundedAmount / 1000);
    const suffix = currency === Currency.RUB ? 'т' : 'k';
    return i18n.t(pattern, { ns: 'translation', amount: shortAmount, suffix });
};
export const getMoneyString = (money) => {
    const formattedAmount = getFormattedAmount(money);
    const { symbol, position } = CurrencyMetaMap[money.currency];
    return position === 'before' ? `${symbol}${formattedAmount}` : `${formattedAmount}${symbol}`;
};
